"use client";

import type { FC } from "react";
import { useWorkspace } from "@/Components/workspace";

const labels = {
    pending: "ACCOUNT.PROFILE_LOADING",
    error: "ACCOUNT.PROFILE_ERROR",
    empty: "ACCOUNT.PROFILE_EMPTY",
    ready: "ACCOUNT.PROFILE_READY",
} as const;

export type ProfileStatusValue = keyof typeof labels;

interface ProfileStatusProps {
    status: ProfileStatusValue;
}

export const ProfileStatus: FC<ProfileStatusProps> = ({ status }) => {
    const { t } = useWorkspace();

    return <small role="status">{t(labels[status])}</small>;
};
